module.exports = __webpack_public_path__ + "img/Buscar.276b893a.svg";